import React from "react";

interface MakulaIconProps {
  icon: React.ReactElement;
  className?: string;
  color?: string;
}

/**
 * MakulaIcon wrapper component that properly applies styles to imported SVG components
 * Handles color inheritance and sizing for SVG icons
 */
export const MakulaIcon = ({
  icon,
  className = "",
  color,
}: MakulaIconProps) => {
  return React.cloneElement(icon, {
    className,
    style: {
      ...icon.props.style,
      ...(color && { stroke: color, color }),
    },
  });
};
